import Vendor from "./Default/Vendor";

export default Vendor;
